import axios from 'axios'

import { FetchBarringRequest, ResponseBarring, BarringData } from '../model/barring.model'

import { getToken } from '~/net'

// eslint-disable-next-line import/prefer-default-export
export class BarringService {
  constructor(private apiGateway: string) {}

  getBarring(fetchBarringRequest: FetchBarringRequest): Promise<ResponseBarring> {
    const { subscriptionId, brand, sub } = fetchBarringRequest

    return getToken()
      .then((token) => {
        let authHeaders = {}

        if (token?.access_token !== 'NO_TOKEN_MOCK') {
          authHeaders = { authorization: `Bearer ${token.access_token}` }
        }

        return axios.get<BarringData>(
          `${this.apiGateway}/customers/v7/orgs/${brand}/subscriptions/${subscriptionId}/barrings`,
          {
            headers: {
              'x-sfid': sub,
              ...authHeaders,
            },
          },
        )
      })
      .then((resp) => ({ subscriptionId, barring: resp.data }))
  }
}
